var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: #003b85;\n      }\n\n      .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 184.55,
    y1: 23.37,
    x2: 30.83,
    y2: 79.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff54ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9c00bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a00a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 178.52,
    y1: 134.27,
    x2: 58.5,
    y2: 164.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae24fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#662aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0026bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 37.97,
    y1: 35.73,
    x2: 119.56,
    y2: 193.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67ffe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00b0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0070bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003ca9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -7.52,
    y1: 16.44,
    x2: 74.07,
    y2: 173.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 203.71,
    y1: 127.86,
    x2: 83.69,
    y2: 158.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 215.75,
    y1: 10.48,
    x2: 62.04,
    y2: 66.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 207.57,
    y1: 48.61,
    x2: 53.87,
    y2: 104.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 206.4,
    y1: 45.4,
    x2: 52.68,
    y2: 101.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 177.58,
    y1: 130.57,
    x2: 57.56,
    y2: 161.1,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.56,49.77c6.55-4.14,14.99-10.08,22.08-14.04-6.1-8.64-18.6.5-22.08,14.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M80.64,35.72c-7.54,3.02-14.45,7.34-20.41,12.65-7.54,12.87-8.04,30.38,3.25,38.49,13.32-20.12,39.1-27.77,61.23-18.41,8.44,3.56,13.41-5.54,6.28-10.53-4.7-3.29-1.22-9.09,5.15-6.89,4.42,1.58,8.53,3.96,11.69,5.76,7.76,4.37,10.92-3.02,6.28-7.34-12.42-11.61-29.12-18.73-47.5-18.73-9.17,0-17.97,1.76-25.96,5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.14,147.26c-9.26,4.91-17.79,3.56-25.6-4.1-4.92-4.82-10.29-9.36-15.53-1.49-4.24,6.48-13.05,5.9-17.34-1.98,1.31,19.99,21.85,30.7,40.36,27.64,8.76-2.16,16.93-5.94,24.07-11.03,7.23-5.18,3.02-13.82-5.96-9.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.99,167.34c-19.42.94-34.86-11.52-40.32-27.64-3.02-8.91-2.98-18.95,1.13-28.49,6.64-15.3,2.8-19.35-9.3-19.54-4.65-.04-8.31-1.89-11.02-4.82-7.72-8.37-7.99-25.88-3.25-38.49,5.01-13.23,15.26-19.94,20.41-12.65-2.8-5.22-8.22-5.54-14.54-2.79-13.59,5.9-25.28,24.31-28.67,43.66-4.7,27.32,2.48,57.84,24.25,76.25,12.1,10.26,27.77,16.43,44.93,16.43,5.64,0,11.15-.68,16.39-1.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.57,117.51c-7-3.6-10.66-3.96-12.91-14.09,2.21,18.86,10.25,36.95,25.01,49.43,1.04.9,2.12,1.76,3.21,2.56-6.01-6.8-9.98-12.6-9.84-24.49.04-4.73,1.62-9.77-5.46-13.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.99,167.34c-12.6-1.75-23.25-9.99-28.17-21.61-4.24,1.3-9.25-.68-12.14-6.03,5.46,16.11,20.9,28.58,40.32,27.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.08,73.8c-10.56,1.26-16.57-16.61-12.73-28.04-1.08.86-2.12,1.71-3.11,2.61-4.74,12.6-4.47,30.11,3.25,38.49,3.43-5.22,7.72-9.59,12.6-13.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.41,78.12c4.34,0,7.86-3.51,7.86-7.83s-3.52-7.83-7.86-7.83-7.86,3.51-7.86,7.83,3.52,7.83,7.86,7.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.4,93.83c5.73,0,10.38-4.64,10.38-10.35s-4.65-10.31-10.38-10.31-10.34,4.64-10.34,10.31,4.65,10.35,10.34,10.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.35,142.27c3.61,0,6.59-2.97,6.59-6.57s-2.98-6.53-6.59-6.53-6.55,2.93-6.55,6.53,2.94,6.57,6.55,6.57h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.817ce6e75ef9f7d39d2458cae1381430.svg";
export { ForwardRef as ReactComponent };